import { motion } from "framer-motion";
import { GALLERY, PROJECTS } from "../data";
import { Reveal, SectionLabel } from "./Reveal";
import { CompareSlider } from "./CompareSlider";

export const BeforeAfter = () => {
  return (
    <section
      id="resultaten"
      className="relative bg-secondary py-24 sm:py-32"
      data-testid="before-after"
    >
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-10">
        <div className="max-w-2xl mb-14">
          <SectionLabel>Voor & Na</SectionLabel>
          <Reveal>
            <h2 className="font-display text-4xl sm:text-5xl lg:text-6xl font-bold tracking-tight text-ink leading-[1.02]">
              Bekijk het resultaat van onze buitenreiniging
            </h2>
          </Reveal>
          <Reveal delay={0.1}>
            <p className="mt-5 text-muted-foreground">
              Recente panden die wij hebben gereinigd. Beweeg de slider om het
              resultaat te ontdekken.
            </p>
          </Reveal>
        </div>

        <div className="grid md:grid-cols-2 gap-6 lg:gap-8">
          {GALLERY.map((g, i) => (
            <Reveal key={g.title} delay={i * 0.1}>
              <CompareSlider item={g} testid={`slider-${i}`} />
            </Reveal>
          ))}
        </div>

        <div className="mt-8 grid sm:grid-cols-3 gap-6">
          {PROJECTS.map((p, i) => (
            <Reveal key={p.title} delay={i * 0.08}>
              <motion.div
                whileHover={{ y: -5 }}
                transition={{ duration: 0.4 }}
                data-testid={`project-${i}`}
                className="group h-full overflow-hidden rounded-3xl border border-border bg-card"
              >
                <div className="relative h-44 overflow-hidden">
                  <img
                    src={p.image}
                    alt={p.title}
                    className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-105"
                  />
                  <span className="absolute left-3 top-3 rounded-full bg-white/90 px-3 py-1 text-xs font-bold text-navy">
                    {p.meta}
                  </span>
                </div>
                <div className="p-6">
                  <h3 className="font-display text-lg font-bold text-ink">
                    {p.title}
                  </h3>
                  <p className="mt-2 text-sm text-muted-foreground leading-relaxed">
                    {p.text}
                  </p>
                </div>
              </motion.div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};

export default BeforeAfter;
